import Vue from 'vue';
import userAppVersionService from './services/appVersion';
import bridgeHandoffService from './services/bridgeHandoff';
import messages from './locale';
import store from './store';

const checkModules = accountModules => (
  (record) => {
    let hasModules = true;
    if (record.meta.requiredModules) {
      record.meta.requiredModules.forEach((m) => {
        if (!accountModules.filter(module => module.name === m).length) {
          hasModules = false;
        }
      });
    }

    return hasModules;
  }
);

const inventoryWritesBlocked = () => {
  const state = store.state.bridgeHandoff.state;

  return !!(state && (state.stock_mutations_handed_off || state.stock_decommissioned));
};

const getBridgeBlockedToastMessage = () => {
  const locale = (store.state.profile.account && store.state.profile.account.language) || process.env.language;
  const fallbackLocale = messages[locale] ? locale : 'en';

  return messages[fallbackLocale].static.bridgeHandoff.blockedToast;
};

const showBridgeBlockedToast = () => {
  if (!Vue.$toast) {
    return;
  }

  Vue.$toast.open({
    message: getBridgeBlockedToastMessage(),
    type: 'warning',
    duration: 6000,
    position: 'top-right',
    queue: false,
  });
};

const getInventoryWriteRedirect = (to) => {
  const matchedRecord = [...to.matched].reverse()
    .find(record => record.meta && record.meta.inventoryBridgeFallback);
  const fallback = matchedRecord && matchedRecord.meta.inventoryBridgeFallback;

  if (!fallback) {
    return { path: '/' };
  }

  const route = {
    name: fallback.name,
  };

  if (fallback.preserveParams) {
    route.params = to.params;
  }

  if (fallback.preserveQuery) {
    route.query = to.query;
  }

  return route;
};

const guardInventoryWriteRoute = (to, next) => {
  if (!to.matched.some(record => record.meta && record.meta.inventoryBridgeStockWrite)) {
    return false;
  }

  const continueNavigation = () => {
    if (!inventoryWritesBlocked()) {
      next();
      return true;
    }

    showBridgeBlockedToast();
    next(getInventoryWriteRedirect(to));
    return true;
  };

  if (store.state.auth.authenticated && store.state.bridgeHandoff.state === null) {
    return bridgeHandoffService.fetch().then(() => continueNavigation());
  }

  return continueNavigation();
};

/**
 * Perform actions before each route
 * @param  {[type]}   to   route to be accessed
 * @param  {[type]}   from route coming from
 * @param  {Function} next resolves the hook, must be called
 * @return {Function}        [description]
 */
const beforeEach = (to, from, next) => {
  /**
   * Authenticated routes.
   */
  if (to.matched.some(record => record.meta.auth)) {
    /**
     * If user is not authenticated, redirect to home.
     */
    if (!store.state.auth.authenticated) {
      return next({
        path: '/home',
      });
    }

    /**
     * If user is unverified, and if so, if it can go through.
     */
    if (Object.keys(store.state.profile.account).length > 0) {
      const verified = store.state.profile.account.verified;
      if (!verified && to.matched.some(record => record.meta.emailVerificationRequired)) {
        return next({
          path: '/',
        });
      }

      /**
       * Checks if user has needed module.
       */
      if (!to.matched.every(checkModules(store.state.profile.account.modules))) {
        return next({
          path: '/',
        });
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    /**
     * If user is authenticated, redirect him to app.
     */
    if (store.state.auth.authenticated) {
      return next({
        path: '/',
      });
    }
  }

  if (guardInventoryWriteRoute(to, next)) {
    return;
  }

  /**
   *  Check new version of the app
   */
  if (store.state.auth.authenticated) {
    Promise.all([
      userAppVersionService.fetchUserAppVersion(),
    ]).then(() => {});
  }

  /**
   * Let user through.
   */
  return next();
};

export default {
  beforeEach,
};



// WEBPACK FOOTER //
// ./src/app/route-middleware.js